export default __webpack_public_path__ + "static/media/raseet-bw-logo-with-name.4fef29e9.png";